import initData from 'init-data';

const { webApiUrl, touchWebUrl } = initData;

export default {
    AVAILABLE_SHIPPING_COUNTRIES:
        webApiUrl + '/member/getavailablecountriesforshipping',
    BANK_ID_AUTHENTICATE: touchWebUrl + 'bankid/authenticate',
    BANK_ID_PROGRESS: touchWebUrl + 'bankid/progress',
    BRAND_LIST_PAGE: touchWebUrl + 'brands/api',
    BRAND_PAGE: touchWebUrl + 'brand/api/',
    CAMPAIGN: campaignId =>
        touchWebUrl +
        'campaign/api/{campaignId}'.replace('{campaignId}', campaignId),
    CART_UPDATE_SUMMARY: touchWebUrl + 'shopping/managecart/updatecartsummary',
    CART_OVERVIEW_VIEW: webApiUrl + '/shopping/checkout/cartoverview',
    CART_ADD_ITEM: webApiUrl + '/shopping/cart/item',
    CART_REMOVE_ITEMS: webApiUrl + '/shopping/cart/removeitems',
    CART_SET_ITEM_QUANTITY: webApiUrl + '/shopping/cart/setitemquantity',
    CHARITY_EARNINGS_TICKER:
        touchWebUrl + 'cache/kampanjer/earningsticker/earnings',
    CMS_API: initData.cmsApiUrl,
    FAVORITE_SELLER_ADD: touchWebUrl + 'my/favourite-sellers/add',
    FAVORITE_SELLER_REMOVE: touchWebUrl + 'my/favourite-sellers/remove',
    GEO_PUBLIC_API_URL: initData.geoPublicApiUrl,
    GET_PROFILE_FEEDBACK_ITEMS: touchWebUrl + 'profile/model',
    HYPERWALLET_PAYOUT_COMPLETE:
        webApiUrl + '/member/paymentprovider/completehyperwallettransfermethod',
    HYPERWALLET_PAYOUT_TOKEN:
        webApiUrl + '/member/paymentprovider/hyperwalletauthenticationtoken',
    HYPERWALLET_PAYOUT:
        webApiUrl +
        '/member/paymentprovider/hyperwallettransfermethodviewmodel',
    INTERNATIONAL_SHIPPING_CALCULATOR:
        webApiUrl + '/browse/internationalshippingcalculator',
    ITEM_DESCRIPTION: itemId =>
        `${webApiUrl}/browse/item/${itemId}/description`,
    ITEM_DISCOUNT_QUOTA: touchWebUrl + 'profile/shop-item-settings/quotas',
    LAST_CHANCE: touchWebUrl + 'StartPage/LastChance',
    MEMBER_PAYOUT_SETTINGS_REMOVE:
        webApiUrl + '/member/profile/removetraderapaypayoutdestination',
    MEMBER_PAYOUT_SETTINGS:
        webApiUrl + '/member/paymentprovider/memberpayoutsettingsviewmodel',
    MEMBER_SYSTEM_MESSAGES: webApiUrl + '/member/system-messages',
    ORDER_CHECKOUT_AUTH_DATA:
        webApiUrl +
        '/shopping/ordercheckout/purchaseorderpaymentattemptauthenticationdata',
    ORDER_CHECKOUT_BRAINTREE:
        webApiUrl + '/shopping/ordercheckout/purchaseorderbraintreeclienttoken',
    ORDER_CHECKOUT_COMPLETE_PAYMENT:
        webApiUrl +
        '/shopping/ordercheckout/completepurchaseorderpaymentattempt',
    ORDER_CHECKOUT_CONFIRMATION:
        webApiUrl +
        '/shopping/ordercheckout/purchaseordercheckoutconfirmationviewmodel',
    ORDER_CHECKOUT_INIT_PAYMENT:
        webApiUrl +
        '/shopping/ordercheckout/initializepurchaseorderpaymentattempt',
    ORDER_CHECKOUT_PAYMENT_OPTIONS:
        webApiUrl + '/shopping/ordercheckout/purchaseorderpaymentoptions',
    ORDER_CHECKOUT_PAYMENT_STATUS:
        webApiUrl + '/shopping/ordercheckout/purchaseorderpaymentattemptstatus',
    ORDER_CHECKOUT_PAYMENT: initData.orderCheckoutPaymentUrl,
    ORDER_CHECKOUT_VIEW:
        webApiUrl + '/shopping/ordercheckout/purchaseordercheckoutviewmodel',
    ORDER_PURCHASE_BIN: webApiUrl + '/shopping/ordercheckout/purchasebin',
    ORDER_PURCHASE_SHOP_ITEMS:
        webApiUrl + '/shopping/ordercheckout/purchaseshopitems',
    PAYMENT_SWISH_OPTOUT: touchWebUrl + 'my/payments2/OptOut',
    PERSONALISED_SUGGESTIONS: '/api/personalised-suggestions',
    SAVED_SEARCH_ADD: touchWebUrl + 'my/savedsearches/add',
    SAVED_SEARCH_NOTIFICATION: touchWebUrl + 'my/savedsearches/notification',
    SAVED_SEARCH_REMOVE: touchWebUrl + 'my/savedsearches/remove',
    SEARCH_SUGGESTIONS: touchWebUrl + 'search/suggestions',
    SEARCH: touchWebUrl + 'search',
    SELLING_ATTRIBUTES: webApiUrl + '/selling/attributes',
    SELLING_SUGGEST_ATTRIBUTES: webApiUrl + '/selling/suggest/attributes',
    SELLING_CATEGORY_RESTRICTIONS: webApiUrl + '/selling/category-restriction',
    SETTINGS: touchWebUrl + 'profile/shop-item-settings/settings',
    SHIPPING_BAGS_ORDER_COUNT_FOR_ITEM: itemId =>
        webApiUrl + `/selling/shipping-bags-order/${itemId}`,
    SHIPPING_BAGS_ORDER_COUNT_TOTAL:
        webApiUrl + '/selling/shipping-bags-order-count',
    SHIPPING_BAGS_ORDER: webApiUrl + '/selling/add-shipping-bags-order',
    SHIPPING_PROVIDERS: webApiUrl + '/selling/shippingproviderswithproducts',
    TOUCHWEB_URL: touchWebUrl,
    TRANSLATE_PROFILE_FEEDBACKITEMS: webApiUrl + '/member/feedback/translated',
    WEB_API: webApiUrl,
    WISHLIST: touchWebUrl + 'my/api/wish-list',
    WISHLIST_ADD: touchWebUrl + 'shopping/wishlist/add',
    WISHLIST_REMOVE: touchWebUrl + 'shopping/wishlist/remove',
    START_OFF_PLATFORM_CHECKOUT:
        touchWebUrl + 'shopping/cartoverview/StartCheckoutSession'
};
